import React, { ChangeEvent, useState } from 'react';
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from '@material-ui/core';

export interface NotificationDialogProps {
  openState: any[];
  checkNotificationState: any[];
}

function NotificationDialog({
  openState,
  checkNotificationState: checkedState,
}: NotificationDialogProps) {
  const [open, setOpen] = openState;
  const [checkNotification, setCheckNotification] = checkedState;

  const [checkboxChecked, setCheckboxChecked] = useState(checkNotification);

  function onDialogClose() {
    closeDialog(checkboxChecked);
  }

  function onCheckboxChange(_: ChangeEvent<HTMLInputElement>, checked: boolean): void {
    setCheckboxChecked(checked);
    if (checked) closeDialog(checked);
  }

  function closeDialog(checked: boolean) {
    setCheckNotification(checked);
    setOpen(false);
  }

  return (
    <Dialog open={open} onClose={onDialogClose} scroll="paper" maxWidth="lg">
      <DialogTitle>
        <Typography variant="h6" style={{ margin: '0px', padding: '1px' }}>
          공지사항
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <img width="100%" src="/notification.png" />
      </DialogContent>
      <DialogActions>
        <FormControlLabel
          control={<Checkbox checked={checkboxChecked} onChange={onCheckboxChange} />}
          label="다시 보지 않기"
        />
      </DialogActions>
    </Dialog>
  );
}

export default NotificationDialog;
